import type { OrderProduct } from "../OrderProduct.js";

export function isSameOrderProduct(first: OrderProduct, second: OrderProduct): boolean {
	return first.productId === second.productId && first.price === second.price;
}
